/* eslint-disable camelcase */
import { VariantCatalogueCooperativeApiResponse, VariantCoreApiResponse } from '@b2ag/module-product-sdk'
import * as taxesMapper from './taxes.mapper'
import * as zoneChargesMapper from './zone-charges.mapper'

export const mapFromVariant = (variant: VariantCoreApiResponse) => ({
  id: variant.id,
  assortable: variant.assortable,
  ean: variant.ean,
  measureQuantity: variant.measure_quantity,
  measureUnit: variant.measure_unit,
  name: variant.name,
  weight: variant.weight,
  isSoldAsUnit: variant.is_sold_as_unit,
  removedFromSource: variant.removed_from_source,
  sellable: variant.sellable,
  offline: variant.offline,
  packaging: variant.packaging,
  articleReferenceSupplier: variant.article_reference_supplier,
})

export const mapFromVariantCatalogueCooperative = (
  variant: VariantCatalogueCooperativeApiResponse = {} as VariantCatalogueCooperativeApiResponse,
) => {
  const { taxes = [], zone_charges: zoneCharges = [] } = variant
  return {
    ...mapFromVariant(variant),
    type: variant.type,
    published: variant.published,
    associated: variant.associated,
    stockManagementType: variant.stock_management_type,
    taxes: taxesMapper.mapFromApi(taxes),
    zoneCharges: zoneCharges.map(zoneChargesMapper.mapFromApi),
    cooperativeVariantId: variant.cooperative_variant_id,
    flowRate: variant.flow_rate,
  }
}
